import { combineReducers } from "redux"
import QuestionData from "./working/QuestionData"
import QuestionDetails from "./working/QuestionDetails"

export default combineReducers({
    QuestionData,
    QuestionDetails
  })